module.exports = __webpack_public_path__ + "img/tlfdysbanner.609ab4f4.png";